import { useState, useRef, useEffect } from 'react';
import { VscClose } from 'react-icons/vsc';
import axios from "axios";
import * as securityHelper from "../../helper/SecurityHelper";

export default function ChgPswrd({ setIsOpenPswrdPop, setNewPw }: any) {
  const ref_originPw = useRef<any>();
  const user: any = securityHelper.getLoginUser();
  const ref_newPw = useRef<any>();
  const ref_newPwRe = useRef<any>();
  const [warnText, setWarnText] = useState('');
  useEffect(() => {
    if (warnText) {
      setTimeout(() => setWarnText(''), 2000)
    }

  }, [warnText]);

  useEffect(() => {
    const originPw = ref_originPw.current.value;
  }, [ref_originPw])

  const fn_cmplt = async () => {
    const originPw = ref_originPw.current.value;
    const newPw = ref_newPw.current.value;
    const newPwRe = ref_newPwRe.current.value;

    if (!originPw) {
      setWarnText('기존 비밀번호를 입력해 주세요.');
      ref_originPw.current.focus()
      return;
    }
    if (!newPw) {
      setWarnText('신규 비밀번호를 입력해 주세요.');
      ref_newPw.current.focus()
      return;
    }
    // 비밀번호 규칙 추가
    // let reg = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/;
    // if(!(reg.test(newPw))){
    //   setWarnText('비밀번호는 숫자,영어,특수문자를 포함한 8자 이상으로 설정해 주세요.');
    //   return;
    // }

    if (newPw !== newPwRe) {
      setWarnText('신규 비밀번호가 서로 일치하지 않습니다.');
      ref_newPwRe.current.focus()
      return;
    }

    const phone = user.phone;
    const rtrnData = await axios.post('admin/api/user/pwReset', { phone: phone, inputPassword: newPw });

    // pwReset 은 갱신 건수를 반환한다. 0이면 실제로 반영되지 않은 것이므로 성공으로 처리하면 안 된다.
    if (!rtrnData.data || rtrnData.data < 1) {
      setWarnText('비밀번호 변경에 실패했습니다. 관리자에게 문의해 주세요.');
      return;
    }

    setNewPw(newPw);
    setIsOpenPswrdPop(false)

  };
  const fn_onOriginPwBlur = async (e: any) => {

    const originPw = e.target.value
    const phone = user.phone;
    const userId = user.userId;
    let phoneOrUserId;

    if (userId) {
      phoneOrUserId = userId;
    } else {
      phoneOrUserId = phone;
    }

    const rtrnData = await axios.post('admin/api/user/isPwCorrect', { phoneOrUserId: phoneOrUserId, inputPassword: originPw });

    if (!rtrnData.data) {
      setWarnText('기존 비밀번호가 일치하지 않습니다.');
      e.target.focus();
    }

  }


  return (
    <div className='w-full h-[calc(100dvh)] absolute flex justify-center items-center bg-black bg-opacity-[70%] z-40 text-txtBlack'>
      <div className={'w-[275px] sm:w-[308px] md:w-[750px] h-[380px] md:h-[950px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center'}>
        <div className='w-full h-44 md:h-[110px] bg-[#F5F5F5] flex justify-between items-center rounded-t-[5px] md:rounded-t-[12px]'>
          <p className='ml-20 text-15 md:ml-[50px] md:text-37 font-preBold'>비밀번호변경</p>
          <VscClose onClick={() => setIsOpenPswrdPop(false)} className='hover:cursor-pointer mr-15 text-22 md:mr-[37px] md:text-55 md:w-[40px]' />
        </div>
        <div className='w-full flex flex-col ml-30 rounded-t-[5px] md:ml-[75px] md:rounded-t-[12px]'>
          <p className='text-15 mt-25 md:text-37 md:mt-[62px]'>기존 비밀번호</p>
          <input type='password' ref={ref_originPw} onBlur={fn_onOriginPwBlur} placeholder={'기존 비밀번호를 입력해 주세요.'} className='w-[255px] sm:w-[274px] md:w-[685px] h-31 mt-5 mb-15 pl-7 md:h-[77px] md:mt-[12px] md:mb-[37px] md:pl-[17px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] md:text-37 font-preLight' />
        </div>
        <div className='w-full flex flex-col ml-30 rounded-t-[5px] md:ml-[75px] md:rounded-t-[12px]'>
          <p className='text-15 md:text-37'>신규 비밀번호</p>
          <input type='password' ref={ref_newPw} placeholder={'신규 비밀번호를 입력해 주세요.'} className='w-[255px] sm:w-[274px] md:w-[685px] h-31 mt-5 mb-15 pl-7 md:h-[77px] md:mt-[12px] md:mb-[37px] md:pl-[17px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] md:text-37 font-preLight' />
        </div>
        <div className='w-full flex flex-col ml-30 rounded-t-[5px] md:ml-[75px] md:rounded-t-[12px]'>
          <p className='text-15 md:text-37'>비밀번호 재입력</p>
          <input type='password' ref={ref_newPwRe} placeholder={'신규 비밀번호를 재입력해 주세요.'} className='w-[255px] sm:w-[274px] md:w-[685px] h-31 mt-5 mb-15 pl-7 md:h-[77px] md:mt-[12px] md:mb-[37px] md:pl-[17px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] md:text-37 font-preLight' />
        </div>
        {warnText ? <div className='w-[67%] top-2/4 h-44 md:h-[110px] absolute  bg-[#2F2F35] flex justify-center items-center text-13 leading-16 md:text-32 md:leading-[40px] font-preLight opacity-80 rounded-[5px] md:rounded-[12px] z-[1000]'>
          <p className='text-15 md:text-37 text-white'>{warnText}</p>
        </div> : null
        }
        <button onClick={fn_cmplt} className='text-white text-15 md:text-37 font-preLight w-89 h-40 md:w-[222px] md:h-[100px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px]'>완료</button>
      </div>
    </div>
  );
}

